import { BEAUTH_PASSWORD_MAX, BEAUTH_PASSWORD_MIN } from '@/config/beauth.config';

const lengthOf = (value: string): number => [...value.normalize('NFC')].length;

export const PASSWORD_RULE_LABEL = `Almeno ${BEAUTH_PASSWORD_MIN} caratteri`;

export default function passwordAcceptable(value: string): boolean {
    const length = lengthOf(value);
    return length >= BEAUTH_PASSWORD_MIN && length <= BEAUTH_PASSWORD_MAX && value.trim() !== '';
}
